import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Inicio.css';
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Image } from 'react-bootstrap';
import banner from '../assets/fechas_confirmadas_colonias_2025.jpg';
 

function Inicio() {
  const navegar = useNavigate();

  const GoLogin = () => {
    navegar(`/Login`);
  };
  const eventos = () => {
    navegar(`/EventoUser`);
  };
  
  const isAuthenticated = () => {
    return !!sessionStorage.getItem('token'); // replace 'token' with your actual key
  };

  return (
    <Container className="mt-5">
      <Row>
        <Col md={6}>
          <h2 className='titulo'>INTRANET COLONIAS</h2>
          <p className='subtitulo'>
            Bienvenido a la Intranet de Colonias, donde podrás gestionar tus inscripciones y
            no te pierdas los nuevos eventos ni la oportunidad de inscribirte.
          </p>
          {!isAuthenticated() && (
          <p className='texto'>Ir al <a href="/login">login</a>.<br/>
            Si no tienes una cuenta, <a href='/register'>regístrate aquí</a>.</p>
            )}
        </Col>
        
        <Col md={6}>
          <Image src={banner} fluid rounded />
        </Col>
      </Row>
      
    </Container>
  );
}

export default Inicio;
